import { __assign, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { TypeFiesta } from '@at/design-system-foundation';
import { BannerIcon } from './banner-icons/banner-icons';
import { BannerTitle, StyledBanner } from './banner.styled';
export var baseClassName = 'atds-banner';
export var Banner = function (_a) {
    var _b = _a.variation, variation = _b === void 0 ? 'default' : _b, _c = _a.type, type = _c === void 0 ? 'in-panel' : _c, aria = _a.aria, children = _a.children, title = _a.title, timeout = _a.timeout, onComplete = _a.onComplete, customIcon = _a.customIcon, otherHTMLProperties = __rest(_a, ["variation", "type", "aria", "children", "title", "timeout", "onComplete", "customIcon"]);
    var _d = useState(false), hideBanner = _d[0], setHideBanner = _d[1];
    var _e = aria || {}, role = _e.role, live = _e.live;
    useEffect(function () {
        if (!!timeout) {
            var timer_1 = window.setTimeout(function () {
                setHideBanner(true);
                if (onComplete)
                    onComplete();
            }, timeout);
            return function () {
                window.clearTimeout(timer_1);
            };
        }
    }, [onComplete, timeout]);
    if (hideBanner) {
        return null;
    }
    return (React.createElement(StyledBanner, __assign({ role: role, "aria-live": live, "$variation": variation, "$type": type }, otherHTMLProperties),
        title && (React.createElement("div", { className: "".concat(baseClassName, "__title") },
            React.createElement(BannerTitle, { as: "h2" }, title))),
        !customIcon ? React.createElement(BannerIcon, { variation: variation }) : customIcon,
        React.createElement(TypeFiesta, { as: "p", className: "".concat(baseClassName, "__copy"), weight: "400" }, children)));
};
